import { g, Tool } from '@hcie/core';
import { drawPen, drawBrush, drawEraser, drawSpray, floodFill, drawRedEye } from '@hcie/tools';
import { getActiveLayer, renderLayers, updateLayerPanel } from '../layers';
import { tempCtx, tempCanvas } from '../rendering-loop';
import { parseColorToRgba } from '@hcie/shared';

export class DrawingToolsHandler {
    static handleMouseDown(e: MouseEvent): boolean {
        const id = g.current_tool.id;
        const checkLayer = getActiveLayer();
        if (!checkLayer || !checkLayer.visible || !checkLayer.ctx) return false;

        const ctx = checkLayer.ctx as CanvasRenderingContext2D;
        const tCtx = tempCtx as CanvasRenderingContext2D;

        if (id === Tool.Pen.id) {
            g.drawing = true;
            console.log(`[DEBUG 2026-04-07][TaskID: Drawing] Pen Down at ${Math.round(g.pX)}, ${Math.round(g.pY)}`);
            drawPen(e, tCtx);
            return true;
        }

        if (id === Tool.Brush.id) {
            g.drawing = true;
            console.log(`[DEBUG 2026-04-07][TaskID: Drawing] Brush Down at ${Math.round(g.pX)}, ${Math.round(g.pY)}`);
            drawBrush(tCtx, g.pX, g.pY);
            return true;
        }

        if (id === Tool.Eraser.id) {
            g.drawing = true;
            // drawEraser expects (ctx, startX, startY, endX, endY)
            drawEraser(tCtx, g.startX, g.startY, g.pX, g.pY);
            return true;
        }

        if (id === Tool.Spray.id) {
            g.drawing = true;
            // drawSpray expects (ctx, MouseEvent?)
            drawSpray(tCtx, e);
            return true;
        }

        if (id === Tool.Flood_Fill.id) {
            const rgba = parseColorToRgba(g.pen_color);
            const tol = { r: g.fill_tolerance, g: g.fill_tolerance, b: g.fill_tolerance, a: g.fill_tolerance };
            // floodFill expects (x, y, targetCtx, fillColor, tolerance)
            floodFill(g.pX, g.pY, ctx, rgba, tol);
            renderLayers();
            updateLayerPanel();
            return true;
        }
        
        if (id === 'btn-red-eye') {
            // drawRedEye expects (sourceCtx, destCtx, x, y, radius, hardness)
            drawRedEye(ctx, tCtx, g.pX, g.pY, g.pen_width / 2, g.brush_hardness);
            return true;
        }

        return false;
    }

    static handleMouseMove(e: MouseEvent): boolean {
        const id = g.current_tool.id;
        if (!g.drawing) return false;
        
        const activeLayer = getActiveLayer();
        if (!activeLayer || !activeLayer.ctx) return false;

        const tCtx = tempCtx as CanvasRenderingContext2D;

        if (id === Tool.Pen.id) {
            drawPen(e, tCtx);
            return true;
        }
        if (id === Tool.Brush.id) {
            drawBrush(tCtx, g.pX, g.pY);
            return true;
        }
        if (id === Tool.Eraser.id) {
            drawEraser(tCtx, g.startX, g.startY, g.pX, g.pY);
            return true;
        }
        if (id === Tool.Spray.id) {
            drawSpray(tCtx, e);
            return true;
        }
        return false;
    }
}
